export const CATEGORIES = [
  { key: "adventure", label: "Adventure", color: "#F97316" },
  { key: "travel", label: "Travel", color: "#38BDF8" },
  { key: "skills", label: "Skills", color: "#A3E635" },
  { key: "career", label: "Career", color: "#FACC15" },
  { key: "health", label: "Health", color: "#34D399" },
  { key: "creative", label: "Creative", color: "#F472B6" },
  { key: "people", label: "People", color: "#FB7185" },
  { key: "other", label: "Other", color: "#94A3B8" },
];

export const categoryOf = (key) => CATEGORIES.find((c) => c.key === key) || CATEGORIES[CATEGORIES.length - 1];

export const CategoryBadge = ({ cat, testId }) => (
  <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[10px] font-mono uppercase tracking-[0.12em]"
    style={{ color: cat.color, background: `${cat.color}1f`, border: `1px solid ${cat.color}40` }} data-testid={testId}>
    <span className="w-1.5 h-1.5 rounded-full" style={{ background: cat.color }} />{cat.label}
  </span>
);
